import { render, staticRenderFns } from "./EnglishProfileAiDialog.vue?vue&type=template&id=48ff87b5"
import script from "./EnglishProfileAiDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishProfileAiDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnglishProfileAiDialog.vue?vue&type=style&index=0&id=48ff87b5&prod&lang=scss"
import style1 from "@/assets/scss/yagiprime/english-profile-ai-dialog.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports